/** biome-ignore-all lint/suspicious/noArrayIndexKey: <explanation> */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { sendApi } from "../../apis/Index";
import Navbar from "../../components/Navbar";
import OrderItem from "./OrderItem";
import OrderSkeleton from "./OrderSkeleton";

const OrdersPage = () => {
  const [order, setOrder] = useState([]);
  const [orderError, setOrderError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const moApi = "https://wittynailtip.com/backend/my-orders.php";
    async function fetchData() {
      try {
        const result = await sendApi(undefined, moApi);
        if (result.data.success) {
          setOrder(result.data.orders);
        } else {
          setOrderError(result.data.message);
        }
      } catch (error) {
        setOrderError(error.message);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (orderError && !orderError.includes("Unauthorized")) {
      toast.error(orderError);
    }
  }, [orderError]);

  return (
    <div className="font-jost bg-gray-50 min-h-screen pb-20">
      <Navbar />
      <div className="md:w-5/6 w-[90%] mx-auto mt-6 md:mt-10 h-full">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 px-2">Order History</h2>
        <div className="w-full space-y-4">
          {loading ? (
            <div className="space-y-4">
              {Array(5).fill(0).map((_, index) => (
                <div key={index} className="bg-white rounded-2xl p-4 shadow-sm">
                  <OrderSkeleton />
                </div>
              ))}
            </div>
          ) : orderError?.includes("Unauthorized") ? (
            <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-white rounded-3xl shadow-sm mt-4">
              <div className="w-24 h-24 bg-[#fff1f5] rounded-full flex items-center justify-center mb-6">
                <svg className="w-10 h-10 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">Sign in required</h2>
              <p className="text-gray-500 mb-8 max-w-md">Please log in to your account to view your complete order history and track recent purchases.</p>
              <Link to="/auth?login=true">
                <button className="bg-gray-900 hover:bg-black text-white px-8 py-3 rounded-full font-medium transition-all shadow-lg hover:-translate-y-1">
                  Go to Login
                </button>
              </Link>
            </div>
          ) : order?.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-white rounded-3xl shadow-sm mt-4">
              <div className="w-24 h-24 bg-[#fff1f5] rounded-full flex items-center justify-center mb-6">
                <svg className="w-12 h-12 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">No orders yet</h2>
              <p className="text-gray-500 mb-8 max-w-md">You haven't placed any orders yet. Once you make a purchase, your beautifully crafted nails will appear here!</p>
              <Link to="/">
                <button className="bg-gray-900 hover:bg-black text-white px-8 py-3 rounded-full font-medium transition-all shadow-lg hover:-translate-y-1">
                  Start Shopping
                </button>
              </Link>
            </div>
          ) : (
            <div className="grid gap-4">
              {order?.map((e, index) => (
                <Link to={`/order/${e.order_id}`} key={index} className="block group">
                  <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow p-2 border border-transparent group-hover:border-[#FFB7CF]/30">
                    <OrderItem e={e} />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersPage;
